import axios from 'axios';
import store from '../app/client-redux/store';
import { navigate as globalNavigate } from '../app/utils/navigate-script';
import { STATUS_OPER_AUTH_ERRORS } from './zps';

const axiosConfig = () => {
  axios.defaults.headers['Content-Type'] = 'application/json;charset=UTF-8';

  axios.interceptors.request.use(
    function (config) {
      const token = store.getState().login?.token;
      // console.log('axios.interceptors current store: store.getState().login', store.getState()?.login);
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    function (error) {
      // console.log('Interceptor promise error: ', error);
      return Promise.reject(error);
    }
  );

  axios.interceptors.response.use(
    function (response) {
      if (STATUS_OPER_AUTH_ERRORS.includes(response?.data?.statusOper?.code)) {
        console.log('Interceptor promise response: ', response);
        globalNavigate('/login');
      }
      return response;
    },
    function (error) {
      if (
        (error.response && error.response.status === 401) ||
        STATUS_OPER_AUTH_ERRORS.includes(error?.response?.data?.statusOper?.code)
      ) {
        console.log('Interceptor promise error: ', error);
        globalNavigate('/login');
        return Promise.reject(error);
      }
      return error;
    }
  );
};

export default axiosConfig;
